export function fromUtf8(str: string) {
    const strUtf8 = unescape(encodeURIComponent(str));
    const bytes = new Uint8Array(strUtf8.length);
    for (let i = 0; i < strUtf8.length; i++) {
        bytes[i] = strUtf8.charCodeAt(i);
    }
    return bytes.buffer;
}

export function toUtf8(buf: ArrayLike<number> | ArrayBufferLike) {
    const bytes = Array.from(new Uint8Array(buf as ArrayBuffer));
    const encodedString = String.fromCharCode.apply(null, bytes);
    return decodeURIComponent(escape(encodedString));
}

export function toB64(buf: ArrayLike<number> | ArrayBufferLike) {
    let binary = '';
    const bytes = new Uint8Array(buf as ArrayBuffer);
    for (let i = 0; i < bytes.byteLength; i++) {
        binary += String.fromCharCode(bytes[i]!);
    }
    return window.btoa(binary);
}

export function hasValue(str: string) {
    return str && str !== '';
}

export const compareOptionalString = (a: string | undefined | null, b: string | undefined | null) => {
  if (!a && !b) {
    return 0;
  }
  if (!a) {
    return -1;
  }
  if (!b) {
    return 1;
  }
  return a.localeCompare(b);
}

export const compareOptionalDate = (a: Date | undefined, b: Date | undefined) => {
  if (a === undefined && b === undefined) {
    return 0;
  }
  if (a === undefined) {
    return -1;
  }
  if (b === undefined) {
    return 1;
  }
  return a.getTime() - b.getTime();
}
